// Module
var code = "<template>\n  <div class=\"mn-tool-bar mn-tool-bar__container\" class.bind=\"_classes\">\n    <slot></slot>\n  </div>\n</template>\n";
// Exports
export default code;